<div class="container">
  <jmkw-radios
    name="Select Persona:"
    [radioNodeMap]="radioNodeMap"
    [selectedId]="currentPersona()"
  ></jmkw-radios>
</div>
